import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i2$1 from 'primeng/selectbutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import * as i3 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { IconComponent } from '@arematics/core/icon';
import * as i4 from 'primeng/dialog';
import { DialogModule } from 'primeng/dialog';
import { BehaviorSubject } from 'rxjs';
import * as i1 from 'ngx-cookie-service-ssr';
import * as i2 from '@arematics/core/api';

var TranslateOption;
(function (TranslateOption) {
    TranslateOption["ORIGINAL"] = "ORIGINAL";
    TranslateOption["TRANSLATED"] = "TRANSLATED";
})(TranslateOption || (TranslateOption = {}));

class TranslateFeatureService {
    cookies;
    arematicsConfig;
    translations;
    options;
    selectedOption = new BehaviorSubject(TranslateOption.ORIGINAL);
    currentDate = new Date();
    cookieDelete;
    constructor(cookies, arematicsConfig) {
        this.cookies = cookies;
        this.arematicsConfig = arematicsConfig;
        this.cookieDelete = new Date(this.currentDate.getFullYear() + 2, this.currentDate.getMonth(), this.currentDate.getDay());
        const translateEnabled = this.cookies.get('translateEnabled');
        if (translateEnabled) {
            this.selectedOption.next(TranslateOption[translateEnabled]);
        }
        this.options = [
            {
                label: this.arematicsConfig.getTranslation('translateOptionOriginal'),
                value: TranslateOption.ORIGINAL
            },
            {
                label: this.arematicsConfig.getTranslation('translateOptionTranslated'),
                value: TranslateOption.TRANSLATED
            }
        ];
    }
    getOptions() {
        return this.options;
    }
    get selected() {
        return this.selectedOption.value;
    }
    get selectedObserve() {
        return this.selectedOption.asObservable();
    }
    changeTranslation(newValue) {
        this.selectedOption.next(newValue);
        this.cookies.set('translateEnabled', newValue, this.cookieDelete, '/');
    }
    isTranslate() {
        return this.selected === TranslateOption.TRANSLATED;
    }
    readProperty(item, originalValue) {
        if (item) {
            if (this.isTranslate() && item && item[`${originalValue}_translated`]) {
                return item[`${originalValue}_translated`] || '';
            }
            else {
                return item[originalValue] || '';
            }
        }
        else {
            return '';
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TranslateFeatureService, deps: [{ token: i1.SsrCookieService }, { token: i2.ArematicsConfig }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TranslateFeatureService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TranslateFeatureService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.SsrCookieService }, { type: i2.ArematicsConfig }]; } });

class TranslateFeatureComponent {
    translate;
    ref;
    infoModal = false;
    options;
    selectedItem;
    constructor(translate, ref) {
        this.translate = translate;
        this.ref = ref;
        this.options = this.translate.getOptions();
        this.selectedItem = this.translate.selected;
        this.translate.selectedObserve.subscribe((next) => {
            this.selectedItem = next;
            this.ref.markForCheck();
        });
    }
    updateItem(event) {
        this.translate.changeTranslation(event);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TranslateFeatureComponent, deps: [{ token: TranslateFeatureService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: TranslateFeatureComponent, isStandalone: true, selector: "a-translate-feature", ngImport: i0, template: `
		<div class="m-2 flex align-items-center justify-content-end" style="gap: 1rem">
			<p-selectButton
				[options]="options"
				[(ngModel)]="selectedItem"
				[allowEmpty]="false"
				styleClass="translateSelect"
				(ngModelChange)="updateItem($event)"></p-selectButton>
			<a-icon icon="circle-info" class="cursor-pointer text-xl" (click)="infoModal = true"></a-icon>
		</div>
		<p-dialog
			i18n-header="@@translate.option.info.title"
			header="Translations (Beta)"
			[(visible)]="infoModal"
			[style]="{ width: '90vw', maxWidth: '500px' }"
			(onHide)="infoModal = false"
			[dismissableMask]="true"
			[draggable]="false">
			<p i18n="@@translate.option.info.text">
				It is now possible to translate contents for courses into the current application language.<br /><br />
				For example if you are currently on the german page, originally english content can be updated into
				german. Since it is automated that feature could contain translation problems.
			</p>
			<p><i i18n="@@translate.option.info.deepl">Powered by DeepL Translate</i></p>
		</p-dialog>
	`, isInline: true, styles: ["::ng-deep .translateSelect{background:linear-gradient(var(--color-background),var(--color-background-accent)) padding-box,linear-gradient(to right,#df9d13,#b41ee1,#fc115f,#e424d6) border-box;border-radius:10px;border:2px solid transparent}::ng-deep .translateSelect .p-button{border:none}::ng-deep .translateSelect .p-button:not(:last-child){border-right:1px solid black}::ng-deep .translateSelect .p-button.p-highlight{font-weight:700}::ng-deep .translateSelect .p-button:hover{background:none;color:var(--color-blue-accent)}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: SelectButtonModule }, { kind: "component", type: i2$1.SelectButton, selector: "p-selectButton", inputs: ["options", "optionLabel", "optionValue", "optionDisabled", "tabindex", "multiple", "allowEmpty", "style", "styleClass", "ariaLabelledBy", "disabled", "dataKey"], outputs: ["onOptionClick", "onChange"] }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: IconComponent, selector: "a-icon[icon]", inputs: ["icon", "size", "solid", "class"] }, { kind: "ngmodule", type: DialogModule }, { kind: "component", type: i4.Dialog, selector: "p-dialog", inputs: ["header", "draggable", "resizable", "positionLeft", "positionTop", "contentStyle", "contentStyleClass", "modal", "closeOnEscape", "dismissableMask", "rtl", "closable", "responsive", "appendTo", "breakpoints", "styleClass", "maskStyleClass", "showHeader", "breakpoint", "blockScroll", "autoZIndex", "baseZIndex", "minX", "minY", "focusOnShow", "maximizable", "keepInViewport", "focusTrap", "transitionOptions", "closeIcon", "closeAriaLabel", "closeTabindex", "minimizeIcon", "maximizeIcon", "visible", "style", "position"], outputs: ["onShow", "onHide", "visibleChange", "onResizeInit", "onResizeEnd", "onDragEnd", "onMaximize"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TranslateFeatureComponent, decorators: [{
            type: Component,
            args: [{ selector: 'a-translate-feature', standalone: true, imports: [CommonModule, SelectButtonModule, FormsModule, IconComponent, DialogModule], template: `
		<div class="m-2 flex align-items-center justify-content-end" style="gap: 1rem">
			<p-selectButton
				[options]="options"
				[(ngModel)]="selectedItem"
				[allowEmpty]="false"
				styleClass="translateSelect"
				(ngModelChange)="updateItem($event)"></p-selectButton>
			<a-icon icon="circle-info" class="cursor-pointer text-xl" (click)="infoModal = true"></a-icon>
		</div>
		<p-dialog
			i18n-header="@@translate.option.info.title"
			header="Translations (Beta)"
			[(visible)]="infoModal"
			[style]="{ width: '90vw', maxWidth: '500px' }"
			(onHide)="infoModal = false"
			[dismissableMask]="true"
			[draggable]="false">
			<p i18n="@@translate.option.info.text">
				It is now possible to translate contents for courses into the current application language.<br /><br />
				For example if you are currently on the german page, originally english content can be updated into
				german. Since it is automated that feature could contain translation problems.
			</p>
			<p><i i18n="@@translate.option.info.deepl">Powered by DeepL Translate</i></p>
		</p-dialog>
	`, changeDetection: ChangeDetectionStrategy.OnPush, styles: ["::ng-deep .translateSelect{background:linear-gradient(var(--color-background),var(--color-background-accent)) padding-box,linear-gradient(to right,#df9d13,#b41ee1,#fc115f,#e424d6) border-box;border-radius:10px;border:2px solid transparent}::ng-deep .translateSelect .p-button{border:none}::ng-deep .translateSelect .p-button:not(:last-child){border-right:1px solid black}::ng-deep .translateSelect .p-button.p-highlight{font-weight:700}::ng-deep .translateSelect .p-button:hover{background:none;color:var(--color-blue-accent)}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslateFeatureService }, { type: i0.ChangeDetectorRef }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { TranslateFeatureComponent, TranslateFeatureService, TranslateOption };
